import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
export default {
  name: "commentList",
  mixins: [loadMoreList],
  data: function data() {
    return {
      pagingReqFn: "commentList",
      pagingReqValue: "data",
      announceList: [],
      date: [],
      content: [],
      paramsData: {
        id: '',
        announce_id: '',
        start_time: '',
        end_time: '',
        state: ''
      },
      drawer: false,
      state: [{
        label: '显示',
        value: 1
      }, {
        label: '隐藏',
        value: 2
      }]
    };
  },
  watch: {
    date: {
      handler: function handler(val) {
        if (val && val.length) {
          this.paramsData.start_time = val[0];
          this.paramsData.end_time = val[1];
        } else {
          this.paramsData.start_time = '';
          this.paramsData.end_time = '';
        }
      },
      immediate: true
    }
  },
  activated: function activated() {
    var _this = this;

    console.log("this.date", this.date);

    if (this.date.length) {
      this.paramsData.start_time = this.date[0];
      this.paramsData.end_time = this.date[1];
    }

    this.getList();
    this.$api.Announce({
      page: 1,
      page_size: -1
    }).then(function (res) {
      if (res.code == 0) {
        _this.announceList = res.data.data;
      }
    });
  },
  methods: {
    changState: function changState(row) {
      var _this2 = this;

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(row.state == 1 ? '隐藏' : '显示', "\u8BE5\u6570\u636E, \u662F\u5426\u7EE7\u7EED?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$api.commentUpdateState({
                  id: row.id,
                  state: row.state == 1 ? 2 : 1
                }).then(function (res) {
                  if (res.code == 0) {
                    _this2.getList();

                    _this2.$message({
                      type: "success",
                      message: res.msg
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    viewOpen: function viewOpen(report) {
      this.content = report;
      console.log("this.content===", this.content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this3 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'commentDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this3.getList();
      });
    }
  }
};